import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Check, Mail, Globe, Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import ContactSupport from '../components/ContactSupport';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const About = () => {
  const features = [
    "AI-powered cycle predictions",
    "Personalized health plans",
    "Expert consultations",
    "Voice AI assistant",
    "WhatsApp health bot",
    "Wearable device sync"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white">
      <Navbar />

      {/* Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          {/* Hero */}
          <div className="text-center mb-16">
            <img
              src="https://customer-assets.emergentagent.com/job_ovalu-design/artifacts/231iio5y_1000063769.jpg"
              alt="Ovalu Logo"
              className="w-24 h-24 mx-auto mb-6 rounded-3xl shadow-xl"
            />
            <h1 className="text-5xl font-bold text-gray-900 mb-4">About Ovalu</h1>
            <p className="text-xl text-gray-600">
              Know Your Cycle. Empower Your Health.
            </p>
          </div>

          {/* Mission */}
          <Card className="p-8 md:p-12 mb-12 border-pink-100 shadow-lg">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              Ovalu empowers women to take control of their reproductive health through
              AI-powered cycle tracking, personalized health insights, and expert consultations.
              We believe every woman deserves access to premium health tools.
            </p>
          </Card>

          {/* Features */}
          <Card className="p-8 md:p-12 mb-12 border-pink-100 shadow-lg">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Features</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-green-600" />
                  </div>
                  <span className="text-gray-700 text-lg">{feature}</span>
                </div>
              ))}
            </div>
          </Card>

          {/* Contact */}
          <Card className="p-8 md:p-12 border-pink-100 shadow-lg">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Contact</h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-pink-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-[#FF6B9D]" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                  <ContactSupport>
                    <span className="text-[#FF6B9D] hover:underline cursor-pointer">
                      support@ovalu.app
                    </span>
                  </ContactSupport>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-pink-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Globe className="w-6 h-6 text-[#FF6B9D]" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Website</h3>
                  <a href="https://www.ovalu.app" target="_blank" rel="noopener noreferrer" className="text-[#FF6B9D] hover:underline">
                    www.ovalu.app
                  </a>
                </div>
              </div>
            </div>
          </Card>

          {/* Contact Support CTA */}
          <Card className="p-8 md:p-12 mt-12 bg-gradient-to-br from-[#FF6B9D] to-[#FFB6C1] border-none text-white text-center rounded-[3rem]">
            <h2 className="text-3xl font-bold mb-4">Need more help?</h2>
            <p className="text-xl mb-8 text-white/90">
              Our support team is always here for you. We'd love to hear from you.
            </p>
            <ContactSupport>
              <Button className="bg-white text-[#FF6B9D] hover:bg-gray-50 rounded-full px-10 py-6 text-xl font-bold shadow-lg hover:shadow-xl transition-all">
                Contact Support
              </Button>
            </ContactSupport>
          </Card>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
